/* eslint-disable no-magic-numbers */
export class XTCIService {
  /**
   * Propertys
   */
  private canceled: boolean = false;
  allowedRequests: string[] = ['hello_request', 'locationlist_request'];
  targetUrl: string = 'https://orderport01.photoprintit.de/xtci2.3/controller';

  executeRequest(
    xml: Document,
    callback: CallableFunction,
    errorCallback: CallableFunction,
    noConnectionMessage: string,
  ) {
    const request = new XMLHttpRequest();
    const XTCI = new XTCIService();

    // console.log('RequestXML: ', xml);
    request.open('POST', this.targetUrl, false);
    // Force the response to be parsed as XML
    request.setRequestHeader('Content-Type', 'text/xml');
    request.onreadystatechange = function () {
      if (this.status === 200 && this.readyState === 4) {
        //console.log('ResponseXML: ', this.responseXML);
        callback(this.responseXML);
      } else {
        this.abort();
        //console.log('error occurred: ', noConnectionMessage);
        errorCallback(noConnectionMessage);
      }
    };

    //send the Http request
    request.send(xml);

    request.ontimeout = function () {
      this.abort();
    };

    // triggered due to a network-level error
    request.onerror = function () {
      this.abort();
      if (!XTCI.canceled) {
        errorCallback(noConnectionMessage);
      }
    };
  }

  createXML(requestType: string, requestData: object) {
    if (this.allowedRequests.indexOf(requestType) === -1) {
      return false;
    }

    const xmlHeader = '<?xml version="1.0" encoding="UTF-8"?>';
    const doctype =
      '<!DOCTYPE ' + requestType + ' SYSTEM "https://orderport01.photoprintit.de/xtci2.3/dtd/' + requestType + '.dtd">';
    let xmloutput = '';

    xmloutput = xmlHeader + doctype;
    xmloutput += '<' + requestType + '>';
    for (const key in requestData) {
      if (Object.prototype.hasOwnProperty.call(requestData, key)) {
        xmloutput += '<' + key + '>' + requestData[key] + '</' + key + '>';
      }
    }
    xmloutput += '</' + requestType + '>';

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmloutput, 'text/xml');

    return xmlDoc;
  }
}

export const XTCI = new XTCIService();
